/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Mobx model(s) related to Practice Assets
 *
 * @file PracticeAssets.js
 * @author Ujjwal Sana
 */

import { types } from 'mobx-state-tree';

const AssetCardProps = types.model('AssetCardProps', {
  url: types.maybeNull(types.string)
});

const PracticeAssets = types.model('PracticeAssets', {
  type: types.maybeNull(types.string),
  question: types.maybeNull(types.string),
  cardProps: types.maybeNull(AssetCardProps)
});

export default PracticeAssets;
